// extracted by mini-css-extract-plugin
export var brand = "_2w-9";
export var button = "_2w-0";
export var chevron = "_2w-v";
export var chevronButton = "_2w-w";
export var content = "_2w-n";
export var danger = "_2w-g";
export var dangerOutlined = "_2w-h";
export var dark = "_2w-l";
export var darkTheme = "_2w-c";
export var extraSmall = "_2w-4";
export var fullWidth = "_2w-8";
export var ghost = "_2w-d";
export var gray = "_2w-t";
export var icon = "_2w-p";
export var iconButton = "_2w-s";
export var iconButtonBorder = "_2w-x";
export var iconButtonBorderDark = "_2w-y";
export var iconButtonBorderLight = "_2w-z";
export var iconLeft = "_2w-q";
export var iconRight = "_2w-r";
export var large = "_2w-1";
export var light = "_2w-m";
export var medium = "_2w-2";
export var micro = "_2w-5";
export var nano = "_2w-7";
export var outlined = "_2w-k";
export var pending = "_2w-a";
export var primary = "_2w-i";
export var shadow = "_2w-o";
export var small = "_2w-3";
export var solidLight = "_2w-e";
export var solidLightBrand = "_2w-f";
export var spinner = "_2w-u";
export var transparent = "_2w-j";
export var warning = "_2w-b";
export var wideNano = "_2w-6";